/* CD 2026-10-15: sticky mobile add-to-cart bar. Lightweight, no dependencies. */
if (!customElements.get('cd-sticky-atc')) {
  customElements.define(
    'cd-sticky-atc',
    class CdStickyAtc extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.labelEl = this.querySelector('[data-cd-sticky-label]');
        this.priceEl = this.querySelector('[data-cd-sticky-price]');
        this.mq = window.matchMedia('(max-width: 749px)');
        this.ticking = false;
        this.onScroll = this.onScroll.bind(this);
        this.onClick = this.onClick.bind(this);
        this.button.addEventListener('click', this.onClick);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.body.classList.remove('cd-sticky-atc-open');
      }

      mainButton() {
        return document.getElementById(this.dataset.submitId);
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        window.requestAnimationFrame(() => {
          this.ticking = false;
          this.update();
        });
      }

      sync(main) {
        const disabled = main.hasAttribute('disabled');
        this.button.toggleAttribute('disabled', disabled);
        const mainLabel = main.querySelector('span');
        const text = mainLabel ? mainLabel.textContent.trim() : '';
        if (text && this.labelEl.textContent.trim() !== text) this.labelEl.textContent = text;
        const priceWrap = document.getElementById(this.dataset.priceId);
        if (priceWrap) {
          const p =
            priceWrap.querySelector('.price--on-sale .price__sale .price-item--sale') ||
            priceWrap.querySelector('.price__regular .price-item--regular');
          const priceText = p ? p.textContent.trim() : '';
          if (priceText && this.priceEl.textContent.trim() !== priceText) this.priceEl.textContent = priceText;
        }
      }

      update() {
        const main = this.mainButton();
        let show = false;
        if (main && this.mq.matches) {
          const rect = main.getBoundingClientRect();
          // Visible only once the main Add to cart button has been scrolled past (above the viewport).
          show = rect.bottom < 0;
          this.sync(main);
        }
        if (show === !this.hidden) return;
        if (show) {
          this.hidden = false;
          window.requestAnimationFrame(() => this.classList.add('is-visible'));
          document.body.classList.add('cd-sticky-atc-open');
        } else {
          if (this.contains(document.activeElement) && main) main.focus({ preventScroll: true });
          this.classList.remove('is-visible');
          this.hidden = true;
          document.body.classList.remove('cd-sticky-atc-open');
        }
      }

      onClick() {
        const main = this.mainButton();
        if (!main || main.hasAttribute('disabled') || main.getAttribute('aria-disabled') === 'true') return;
        main.click();
      }
    }
  );
}
